exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.type-name[data-v-24245f0e] {\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.cell-item[data-v-24245f0e] {\n  position: relative;\n  cursor: pointer;\n}\n.cell-item-box[data-v-24245f0e] {\n  position: relative;\n}\n.cell-item-box:hover .el-icon-circle-close[data-v-24245f0e] {\n    display: block;\n}\n.cell-item-box .el-icon-circle-close[data-v-24245f0e] {\n    display: none;\n    cursor: pointer;\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    color: #ff5000;\n    z-index: 2;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-24245f0e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/reservation/resourcesetting/workshift.vue
// module id = 1297
// module chunks = 0